import { Col, Row } from "antd";
import React from "react";

declare global {
  namespace JSX {
      interface IntrinsicElements {
          'wax-marketplace': { collections: string }
      }
  }
}
export default function Demo() {
  return <Row gutter={[8,48]}>
    <Col xs={24}>
      <h2 className="color-primary center-when-mobile">Live demo</h2>
    </Col>
    <Col xs={24}> <wax-marketplace collections='bcbrawlers,dc.funko,alien.worlds'/></Col>
  </Row>;
}
